import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useEffect, useRef, useState } from 'react';
import { getInputValue, setInputValue } from '../../util/refUtils';
import { crearDuenoSiniestro, eliminarDuenoSiniestro, modificarDuenoSiniestro } from '../../services/Siniestro/SiniestroService';
import { Dialog } from 'primereact/dialog';
import { ConfirmDialog } from 'primereact/confirmdialog';
import SelectorUbicacion from '../DatosEmpleado/SelectorUbicacion';
import { ColorPicker } from 'primereact/colorpicker';
import AsignaRutas from './AsignaRutas';
import AsignaUsuarios from './AsignaUsuarios';

const NuevoPuesto = ({ toast, clienteDat, proyectoDat, funcSalir, puestoDat }) => {
    //console.log('HHHH DATOS DEL PUESTO..:', puestoDat)
    const refNombrePuesto = useRef();
    const refUbiPuesto = useRef();
    const [grabando, setGrabando] = useState(false);
    const [mostrarMap, setMostrarMap] = useState(false);
    const [color, setColor] = useState(null);
    const [verRutas, setVerRutas] = useState(false);
    const [visibleUsers, setVisibleUsers] = useState(false);
    const [confEliminar, setConfEliminar] = useState(false);
    const [eliminando, setEliminando] = useState(false);

    useEffect(() => {
        const iniciar = () => {
            if (puestoDat?.configuracionDetId) {
                setInputValue(refNombrePuesto, puestoDat?.nombre);
                const datoJson = JSON.parse(puestoDat?.parametro);
                setInputValue(refUbiPuesto, datoJson.ubicacion);
                setColor(datoJson.color);
            }
        };
        iniciar();
    }, [puestoDat]);

    const handleGuardar = async () => {
        const valPuesto = getInputValue(refNombrePuesto);
        const valUbiPuesto = getInputValue(refUbiPuesto);
        if (!valPuesto) {
            toast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe llenar el campo Nombre.'
            });
            return;
        }
        if (!valUbiPuesto) {
            toast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe llenar el campo Ubicacion.'
            });
            return;
        }
        if (!color) {
            toast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe Seleccionar un Color.'
            });
            return;
        }

        try {
            setGrabando(true);
            const objParametro = {
                ubicacion: valUbiPuesto,
                color: color
            };
            const CODE_CONFIGCAB_PUESTO = 'SIN-0000-0004';
            const objPost = {
                configuracionCabId: 0,
                padreConfiguracionDetId: proyectoDat?.configuracionDetId,
                codigo: 'nuevo',
                nombre: valPuesto
            };
            let datos;
            if (puestoDat?.configuracionDetId) {
                objPost['configuracionDetId'] = puestoDat?.configuracionDetId;
                const datoJson = JSON.parse(puestoDat?.parametro);
                objParametro['ubicacionId'] = datoJson.ubicacionId;
                objParametro['codigo'] = datoJson.codigo
                objPost['parametro'] = JSON.stringify(objParametro);
                datos = await modificarDuenoSiniestro(objPost, CODE_CONFIGCAB_PUESTO);
            } else {
                objParametro['codigo'] = crypto.randomUUID()
                objPost['parametro'] = JSON.stringify(objParametro);
                datos = await crearDuenoSiniestro(objPost, CODE_CONFIGCAB_PUESTO);
            }
            if (datos?.configuracionDetId) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Exito',
                    detail: 'Se ha registrado el Puesto.'
                });
            }
        } catch (error) {
            console.error('ERROR: Error al creaar el Puesto');
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al registrar el Puesto.'
            });
        } finally {
            setGrabando(false);
            funcSalir();
        }
    };

    const confirmaMapa = (puntoMapa) => {
        //console.log ('HHHHHconfirma Punto: ', puntoMapa)
        setInputValue(refUbiPuesto, puntoMapa);
        setMostrarMap(false);
    };
    const cancelaMapa = () => {
        //console.log ('cancela')
        setMostrarMap(false);
    };

    const mostrarRutas = () => {
        setVerRutas(true);
    };

    const ocultarRutas = () => {
        setVerRutas(false);
    };

    const verAsigUsuario = () => {
        setVisibleUsers(true);
    };

    const salirUsuarios = () => {
        setVisibleUsers(false);
    };

    const pedirEliminar = () => {
        setConfEliminar(true);
    };

    const confirmarEliminar = async () => {
        if (!puestoDat?.configuracionDetId) return;
        try {
            setEliminando(true);
            await eliminarDuenoSiniestro(puestoDat.configuracionDetId);
            toast.current.show({
                severity: 'success',
                summary: 'Exito',
                detail: 'Puesto eliminado.'
            });
            setConfEliminar(false);
            funcSalir();
        } catch (error) {
            console.error('ERROR: Error al eliminar el Puesto');
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar el Puesto.'
            });
        } finally {
            setEliminando(false);
        }
    };

    return (
        <div className="card">
            <Dialog visible={mostrarMap} onHide={() => setMostrarMap(false)}>
                <SelectorUbicacion
                    onConfirmar={confirmaMapa}
                    onCancelar={cancelaMapa}
                    coordenadaInicial={getInputValue(refUbiPuesto)}
                />
            </Dialog>
            <Dialog visible={verRutas} onHide={() => setVerRutas(false)} header='Asignar Rutas'>
                <AsignaRutas datPuesto={puestoDat} funcSalir={ocultarRutas} />
            </Dialog>
            <Dialog
                visible={visibleUsers}
                onHide={() => setVisibleUsers(false)}
                header="Asignar Usuarios"
                style={{ width: '60vw' }}
            >
                <AsignaUsuarios datosPuesto={puestoDat} funcSalir={salirUsuarios} toast={toast} />
            </Dialog>
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-4">
                    <label>Nombre Cliente:</label>
                </div>
                <div className="field col-12 md:col-8">
                    <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">
                        {clienteDat.nombre}
                    </span>
                </div>
                <div className="field col-12 md:col-4">
                    <label>Nombre Proyecto:</label>
                </div>
                <div className="field col-12 md:col-8">
                    <span className="inline-block w-full bg-gray-100 border border-gray-300 text-gray-600 p-2 rounded-md text-base shadow-inner">
                        {proyectoDat.nombre}
                    </span>
                </div>
                <div className="field col-12 md:col-12">
                    <label>Nombre del Puesto</label>
                    <InputText
                        ref={refNombrePuesto}
                        defaultValue=""
                        onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
                        maxLength={100}
                    />
                </div>
                <div className="field col-12 md:col-5">
                    <label>Ubicacion Puesto:</label>
                    <InputText
                        ref={refUbiPuesto}
                        defaultValue=""
                        onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
                        maxLength={100}
                    />
                </div>
                <div className="field col-12 md:col-2 flex align-items-end">
                    <Button icon="pi pi-map-marker" onClick={() => setMostrarMap(true)} />
                </div>
                <div className="field col-12 md:col-3">
                    <label>Color</label> <br />
                    <div className="flex justify-content-center">
                        <ColorPicker value={color || 'ffffff'} onChange={(e) => setColor(e.value)} format="hex" />
                    </div>
                </div>
                <div className="field col-12 md:col-2">
                    {color ? (
                        <label style={{ visibility: 'hidden' }}>Texto oculto</label>
                    ) : (
                        <span style={{ color: 'red' }}>* Selecciona un color</span>
                    )}
                </div>
                <div className="field col-12 md:col-3 flex align-items-end">
                    <Button
                        label="Usuarios"
                        icon="pi pi-user-edit"
                        disabled={!puestoDat?.configuracionDetId}
                        onClick={verAsigUsuario}
                    />
                </div>
                <div className="field col-12 md:col-3 flex align-items-end">
                    <Button
                        label="Asociar Ruta"
                        icon="pi pi-truck"
                        disabled={!puestoDat?.configuracionDetId}
                        onClick={mostrarRutas}
                    />
                </div>
                <div className="field col-12 md:col-3 flex align-items-end">
                    <Button
                        label="Eliminar"
                        className="p-button-danger"
                        icon="pi pi-trash"
                        disabled={!puestoDat?.configuracionDetId}
                        onClick={pedirEliminar}
                        loading={eliminando}
                    />
                </div>
                <div className="field col-12 md:col-3 flex align-items-end">
                    <Button
                        label="Guardar"
                        className="p-button-primary"
                        icon="pi pi-save"
                        onClick={handleGuardar}
                        loading={grabando}
                    />
                </div>
            </div>
            <ConfirmDialog
                visible={confEliminar}
                onHide={() => setConfEliminar(false)}
                message={`¿Confirma eliminar el puesto "${puestoDat?.nombre}"?`}
                header="Eliminar Puesto"
                icon="pi pi-exclamation-triangle"
                acceptLabel="Si"
                rejectLabel="No"
                acceptClassName="p-button-danger"
                accept={confirmarEliminar}
            />
        </div>
    );
};

export default NuevoPuesto;
